import styled from '@emotion/styled';
import { BodyTextMedium, HeadingText50 } from '@modernhealth/vital-components';
import { Icon, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { color } from 'src/shared/styles/variables';
import { CodingPersonSVG } from '../svg/CodingPersonSVG';

export enum SubmissionModalContainerTestID {
    Wrapper = 'SubmissionModalContainerTestID.Wrapper',
    Spinner = 'SubmissionModalContainerTestID.Spinner',
}

const StyledModal = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: color.white,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
});

const ModalBoundary = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 520,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: '2.75rem',
});

export interface StandardSpinnerProps {
    delay: number;
    iconColor: string;
    fontSize: number;
}
const StandardSpinner = ({ delay, iconColor, fontSize }: StandardSpinnerProps) => (
    <Spin
        delay={delay}
        indicator={
            <Icon
                type="loading"
                spin
                data-testid={SubmissionModalContainerTestID.Spinner}
                style={{ color: iconColor, fontSize }}
            />
        }
    />
);

const IconWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
});

export const SubmissionModalContainer = () => {
    const { t } = useTranslation();

    return (
        <StyledModal data-testid={SubmissionModalContainerTestID.Wrapper}>
            <ModalBoundary>
                <StandardSpinner delay={0} iconColor={color.casper} fontSize={50} />
                <IconWrapper>
                    <CodingPersonSVG width={321} height={313} />
                </IconWrapper>

                <HeadingText50 marginBottom={30} centered>
                    {t('insuranceForm:submission_modal.title')}
                </HeadingText50>

                <BodyTextMedium centered marginBottom={28} maxWidth="454px" fontColor="gray65">
                    {t('insuranceForm:submission_modal.description')}
                </BodyTextMedium>
            </ModalBoundary>
        </StyledModal>
    );
};
